export const DEFAULT_EXCEL_HEADER = [
  "연번",
  "근무지",
  "구분",
  "소속",
  "부서",
  "계급(직위)",
  "이름",
  "전화번호",
  "임무",
];

export const FIELD_KEYS = [
  "workplace",
  "personTypeLabel",
  "porg",
  "pdept",
  "prank",
  "pname",
  "pphone",
  "dutyDesc",
];

export const SMS_LINK_PREFIX = "지원인력";

/** 랜덤 생성 기본 행 수 */
export const RANDOM_ROW_DEFAULT_COUNT = 10;
